/**
 * external libs
 */
import axios from 'axios';
/**
 * internal services
 */
import {
	API_ACCEPT_INVITATION_URL,
	API_AUTH_COR_ID_GET_QR,
	API_AUTH_REFRESH_URI,
	API_BASE_URL,
	API_VALIDATE_INVITATION_URL
} from "../constants/api.constant";
import StorageService from "../services/storage.service";
import {TokenUtils, getLang} from 'cor-business'
// Создаем отдельный axios instance для cor-taskman
export const taskmanAxios = axios.create({
	baseURL: API_BASE_URL
});

let refreshDoing = false;
const AUTH_BYPASS_URLS = new Set([
	API_VALIDATE_INVITATION_URL,
	API_ACCEPT_INVITATION_URL,
	API_AUTH_COR_ID_GET_QR,
]);

const langHeaderMap = { ua: 'uk', en: 'en', ru: 'ru' };

taskmanAxios.interceptors.request.use(async (req) => {
	const savedLang = getLang() || 'en';
	const headerLang = langHeaderMap[savedLang] || savedLang;
	req.headers["Accept-Language"] = `${headerLang};q=1`

	if(API_AUTH_REFRESH_URI === req.url){
		if (refreshDoing) {
			throw new taskmanAxios.Cancel("Blocked request to refresh URL");
		}

		refreshDoing = true
		return req;
	}

	if (AUTH_BYPASS_URLS.has(req.url)) {
		return req;
	}

	await new Promise((resolve) => {
		if(!refreshDoing){
			resolve(true)
			return
		}

		const intervalId = setInterval(() => {
			if(!refreshDoing){
				clearInterval(intervalId)
				resolve(true)
			}
		}, 200)
	})

	refreshDoing = false
	let accessToken = await TokenUtils.getAccessToken();
	if(accessToken){
		req.headers.Authorization = `Bearer ${accessToken}`;
	}
	return req;
});

taskmanAxios.interceptors.response.use(
	(response) => {
		if(response?.config?.url === API_AUTH_REFRESH_URI){
			refreshDoing = false;
		}
		return response
	},
	async (error) => {
		if(error?.config?.url === API_AUTH_REFRESH_URI){
			refreshDoing = false;
		}

		// Log the error for debugging
		console.error('API Error:', {
			status: error.response?.status,
			statusText: error.response?.statusText,
			data: error.response?.data,
			url: error.config?.url,
			method: error.config?.method
		});

		if(error.response?.status === 401){
			console.warn('401 Unauthorized:', error.config?.url)
			return Promise.reject(error?.response || error);
		}

		return Promise.reject(error?.response || error);
	},
);

export default taskmanAxios;
